import React from 'react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { OnCallCard } from './OnCallCard';

// One info-column card per Component/System entity page. Same data on every
// page (Aknostic platform pages on everything) — the card is informative,
// not entity-specific, but lives on the entity page to put on-call info
// where engineers naturally land when investigating something.
//
// OnCallCard is imported eagerly (top-level) rather than via `await import`
// inside the loader. Dynamic import creates a separate webpack chunk; when
// a deploy changes chunk hashes, browsers with a cached main bundle still
// reference the old chunk URL → 404 → React silently drops the card. Eager
// import puts OnCallCard in the main bundle, so cache-invalidation lines
// up correctly. ~5KB bundle-size cost; worth it for the deploy reliability.
const onCallCard = EntityCardBlueprint.make({
  name: 'goalert-oncall',
  params: {
    loader: async () => React.createElement(OnCallCard),
    filter: { kind: { $in: ['component', 'system'] } },
    type: 'info',
  },
});

export const goalertModule = createFrontendModule({
  pluginId: 'app',
  extensions: [onCallCard],
});
